import { FormikProvider } from "formik";
import MultiStepWrapper from "./components/MultiStepWrapper";
import useAddForm from "../hooks/useAddForm";
import useBreadcrumbs from "@/hooks/store/useBreadcrumbs";
import { useEffect } from "react";

const AddAdmin = () => {
  const formik = useAddForm();
  const { setRoutes } = useBreadcrumbs();
  useEffect(() => {
    setRoutes([
      {
        name: "Admin center",
        path: "/admins",
      },
      {
        name: "MSP admins",
        path: "/admins",
      },
      {
        name: "Add admin",
        description:
          "Add a new MSP admin to manage global settings, billing, and organization-wide operations. MSP admins have elevated privileges to oversee client accounts and platform configuration.",
        helpLink:
          "https://help.trio.so/en/articles/12530390-msp-admins-in-trio",
      },
    ]);
  }, []);
  return (
    <FormikProvider value={formik}>
      <MultiStepWrapper />
    </FormikProvider>
  );
};

export default AddAdmin;
